import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import DataAccess from './data-access';
import Employee from './employee';
import Reports from './reports';
import Vehicle from './vehicle';
import Parking from './parking';
import Roles from './roles';
import ControlPanel from './control-panel';
import Dashboard from './dashboard';
import Payment from './payment';
import Messages from './messages';
import Campaign from './campaign';
import Consumer from './consumer';
import Zone from './zone';
import TariffSchedule from './tariff-schedule';
import TariffPlan from './tariff-plan';
import RelateTariffSchedule from './relate-tariff-schedule';
import AccountingCash from './accounting-cash';
import Labels from './labels';
import Client from './client';
import FinancialAccount from './financial-account';
import GuardRequest from './guard-request';
import ParkingDashboard from './parking-dashboard';
import PriceTicket from './price-ticket';
import PointInterest from './point-interest';
import Ocr from './ocr';
import AllowPayment from './allow-payment';
import Atm from './atm';
import PrintConfig from './print-config';
import ReactivePayment from './reactive-payment';
import Serpro from './serpro';

export const store = createStore({
  plugins: [createPersistedState()],
  modules: {
    'DATA-ACCESS': DataAccess,
    EMPLOYEE: Employee,
    REPORTS: Reports,
    VEHICLE: Vehicle,
    PARKING: Parking,
    ROLES: Roles,
    'CONTROL-PANEL': ControlPanel,
    DASHBOARD: Dashboard,
    PAYMENT: Payment,
    MESSAGES: Messages,
    CAMPAIGN: Campaign,
    CONSUMER: Consumer,
    ZONE: Zone,
    'TARIFF-SCHEDULE': TariffSchedule,
    'TARIFF-PLAN': TariffPlan,
    RELATE: RelateTariffSchedule,
    'ACCOUNTING-CASH': AccountingCash,
    LABELS: Labels,
    CLIENT: Client,
    'FINANCIAL-ACCOUNT': FinancialAccount,
    'GUARD-REQUEST': GuardRequest,
    'PARKING-DASHBOARD': ParkingDashboard,
    'PRICE-TICKET': PriceTicket,
    'POINT-INTEREST': PointInterest,
    OCR: Ocr,
    'ALLOW-PAYMENT': AllowPayment,
    ATM: Atm,
    'PRINT-CONFIG': PrintConfig,
    'REACTIVE-PAYMENT': ReactivePayment,
    SERPRO: Serpro,
  },
});
